import React, { useEffect, useRef } from 'react';

const BlackHoleBackground = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      video.pause();
      return;
    }

    // Algumas extensões (bloqueadores de autoplay, etc.) pausam o vídeo
    // depois que ele já começou a tocar. Como é só um fundo decorativo
    // silencioso, tentamos retomar a reprodução sempre que isso acontecer.
    video.muted = true;
    const tryPlay = () => video.play().catch(() => {});
    tryPlay();

    const handlePause = () => tryPlay();
    video.addEventListener('pause', handlePause);
    return () => video.removeEventListener('pause', handlePause);
  }, []);

  return (
    // z-0 e não -z-10: com z-index negativo o vídeo é pintado ATRÁS do
    // background do <body>, então qualquer extensão (ou CSS futuro) que
    // pinte um fundo opaco no body/html o esconde por completo. Em z-0 ele
    // fica acima desse fundo, e o conteúdo (z-10 no App) segue acima dele.
    <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" style={{ background: '#000' }}>
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        src="/videos/black-hole.1920x1080.mp4"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />
      <div className="absolute inset-0 bg-black/40" />
    </div>
  );
};

export default BlackHoleBackground;
